import React, { useMemo } from 'react';
import { Row, Col, Grid } from 'antd';
import indexStyles from '../index.less';
import FrozenRatio from 'src/components/FrozenRatio/FrozenRatio';
import { JoinClassName } from 'src/utils/utils';
import CommonSection from '../CommonSection';
import { useIntl } from 'react-intl';
import UnoptimizedImage from 'src/components/UnoptimizedImage';
const { useBreakpoint } = Grid;

const OurCustomerBrandWall = () => {
  const intl = useIntl();
  const screens = useBreakpoint();
  const customerBrandLogoList = useMemo(() => {
    return [
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/tiger_sugar.png`,
        alt: 'tigersugar',
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/xiangtianxia.jpg`,
        alt: 'xiang_tian_xiao',
        // width: 164,
        width: 492,
        height: 453,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/liu_yi_shou.png`,
        alt: 'liu_yi_shou',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/xiaolongkai.png`,
        alt: 'xiaolongkai',
        // width: 164,
        width: 492,
        height: 382,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/nan_huo_guo.png`,
        alt: 'nan_huo_guo',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/jiang_nan.png`,
        alt: 'jiang_nan',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/yuan_cha.png`,
        alt: 'yuan_cha',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/kyuramen_01.png`,
        alt: 'kyuramen',
        // width: 164,
        width: 492,
        height: 492,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/the_whale_tea.png`,
        alt: 'The Whale Tea',
        // width: 134,
        width: 492,
        height: 257,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/vivi_bubble_tea.png`,
        alt: 'Vivi Bubble Tea',
        // width: 134,
        width: 492,
        height: 492,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/xing_fu_tang.png`,
        alt: 'xing Fu Tang',
        // width: 134,
        width: 492,
        height: 492,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/machi_machi.png`,
        alt: 'machimachi',
        // width: 164,
        width: 492,
        height: 492,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/craftycrab.png`,
        alt: 'craftycrab',
        // width: 164,
        width: 492,
        height: 492,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/teamo_01.png`,
        alt: 'teamo',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/jongrobbq.png`,
        alt: 'jongrobbq',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/kong_fu_cha.png`,
        alt: 'kong_fu_cha',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/mochi_nut.png`,
        alt: 'mochi_nut',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/one_zo.png`,
        alt: 'one_zo.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/chao_cha.png`,
        alt: 'chao_cha.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/bu_er_jia.png`,
        alt: 'bu_er_jia.png',
        // width: 164,
        width: 492,
        height: 492,
      },

      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/lao_jiu_men.png`,
        alt: 'lao_jiu_men.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/gang_guan_wu_qu.png`,
        alt: 'gang_guan_wu_qu.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/cha_tang_hui.png`,
        alt: 'cha_tang_hui.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/lao_sze_chuan.png`,
        alt: 'lao_sze_chuan.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/dun_huang.png`,
        alt: 'dun_huang.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/ma_la.png`,
        alt: 'ma_la.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/lao_gao_bbq.png`,
        alt: 'lao_gao_bbq.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/yu_wei_xiao_yu.png`,
        alt: 'yu_wei_xiao_yu.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/you_qin_ke_chuan.png`,
        alt: 'you_qin_ke_chuan.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/ka_ji_ken.png`,
        alt: 'ka_ji_ken.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/egg_lab.png`,
        alt: 'egg_lab.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/croffle_haus.png`,
        alt: 'croffle_haus.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/brooklyn.png`,
        alt: 'brooklyn.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/jongro_rice_hot_dog.png`,
        alt: 'jongro_rice_hot_dog.png',
        // width: 164,
        width: 492,
        height: 492,
      },
      {
        logo: `${process.env.ASSETS_PREFIX}/home/clients-logo/space_ktv_bar_lounge.png`,
        alt: 'space_ktv_bar_lounge',
        // width: 164,
        width: 492,
        height: 156,
      },
    ];
  }, []);

  return (
    <CommonSection
      title={intl.formatMessage({ id: 'home.chowbuspos.trusted_by_top_restaurants' })}
      className={JoinClassName(indexStyles.max1440WidthFull, indexStyles.ourCustomerBrandWallSection)}
      outerClassName={JoinClassName(indexStyles.whiteBackgroundcolor)}
    >
      <div className={JoinClassName(indexStyles.ourCustomerBrandWall, screens.xs ? indexStyles.mobile : '')}>
        <Row align={'middle'} justify={'center'} wrap={true}>
          {customerBrandLogoList.map(({ logo, alt, width, height }, index) => {
            return (
              <Col xs={8} sm={8} md={6} lg={4} xxl={3} key={index}>
                <FrozenRatio ratio={1}>
                  <div className={JoinClassName(indexStyles.customerBrandContainer)}>
                    <img
                      src={logo}
                      alt={alt}
                      width={width}
                      height={height}
                      style={{ objectFit: 'contain', maxWidth: `100%`, maxHeight: '100%' }}
                    />
                  </div>
                </FrozenRatio>
              </Col>
            );
          })}
        </Row>
      </div>
    </CommonSection>
  );
};

export default OurCustomerBrandWall;
